export const START_TEAMNAT_GAME_COMPLETED = "teamNationality/startCompleted";
export const GUESS_TEAMNAT_COMPLETED = "teamNationality/guessCompleted";
export const GET_TEAMNAT_SUGGESTIONS_COMPLETED = "teamNationality/suggestionsCompleted";
export const CLEAR_TEAMNAT_SUGGESTIONS = "teamNationality/clearSuggestions";
